import { useTranslations } from "../../lib/translations"

export function Legend() {
  const t = useTranslations()
  return (
    <div className="cm-legend">
      <h6>{t("canvas.legend.heartbeat")}</h6>
      <div className="row"><span className="d" style={{ background: "var(--ok)" }} />{t("canvas.legend.healthy")}</div>
      <div className="row"><span className="d" style={{ background: "var(--warn)" }} />{t("canvas.legend.await")}</div>
      <div className="row"><span className="d" style={{ background: "var(--bad)" }} />{t("canvas.legend.degraded")}</div>
      <div className="row"><span className="d" style={{ background: "var(--ink-3)" }} />{t("canvas.legend.off")}</div>
      <h6 style={{ marginTop: 9 }}>{t("canvas.legend.structure")}</h6>
      <div className="row"><span style={{ width: 20, height: 2, background: "var(--line-2)", borderRadius: 2 }} />{t("canvas.legend.tree")}</div>
      <div className="row"><span className="d" style={{ background: "transparent", border: "1px dashed var(--line-2)" }} />{t("canvas.legend.independent")}</div>
    </div>
  )
}
